export default "__VITE_PUBLIC_ASSET__05fc56c0__"